import type { InputOption } from '@yescapa-dev/ysc-components/dist/runtime/types'

export const useSearchFiltersOptions = () => {
  const { $i18n: { t, n } } = useNuxtApp()

  const passengersOptions = computed((): InputOption<number | null>[] => {
    return [
      ...arrayRange(4, 2).map(value => ({ value, text: n(value) })),
      { value: 6, text: t('components.app_search.filters.6_more') },
    ]
  })

  const licenseOptions = computed((): InputOption<number | null>[] => [
    { value: null, text: t('components.app_search.filters.license_all') },
    { value: 1, text: t('components.app_search.filters.license_b') },
    { value: 2, text: t('components.app_search.filters.license_c') },
  ])

  const reviewAverageOptions = computed((): InputOption<number | null>[] => [
    { value: null, text: t('components.app_search.filters.all_reviews') },
    { value: 3.5, text: n(3.5) },
    { value: 4, text: n(4) },
    { value: 4.5, text: n(4.5) },
  ])

  const ownerOptions = computed((): InputOption<number | null>[] => [
    { value: null, text: t('components.app_search.filters.owner_all') },
    { value: 1, text: t('components.app_search.filters.owner_private') },
    { value: 2, text: t('components.app_search.filters.owner_pro') },
  ])

  return { passengersOptions, licenseOptions, reviewAverageOptions, ownerOptions }
}
